module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row outer-frame"
  }, [_c('div', {
    staticClass: "col-xs-12 mv10 f15"
  }, [_c('a', {
    staticClass: "black",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.topic.click()
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), (_vm.topic.activeModuleMenu && _vm.topic.activeChildMenu) ? _c('a', {
    staticClass: "black",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.topic.activeModuleMenu.click()
      }
    }
  }, [_vm._v("\n\t\t\t\t/ " + _vm._s(_vm.topic.activeModuleMenu.name) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.topic.activeModuleMenu && !_vm.topic.activeChildMenu) ? _c('span', [_vm._v("/ " + _vm._s(_vm.topic.activeModuleMenu.name))]) : _vm._e(), _vm._v(" "), (_vm.topic.activeChildMenu) ? _c('span', [_vm._v("/ " + _vm._s(_vm.topic.activeChildMenu.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.topic.activeModuleMenu && _vm.topic.activeModuleMenu.menus) ? _c('div', _vm._l((_vm.topic.activeModuleMenu.menus), function(menu) {
    return _c('div', [_c('div', {
      staticClass: "menu-item",
      class: {
        'active': _vm.topic.activeChildMenu && _vm.topic.activeChildMenu.location === menu.location
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$router.push(menu.getUrl())
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(menu.name) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div')])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 bg-white mb40"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-72b729c4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/article/Outer.vue
// module id = 1005
// module chunks = 1